import React from 'react';
import { styled, Media } from 'themes';
import { Img, Text } from 'components';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

const YepTestimonials = () => {
  const [t] = useTranslation();
  const images = useStaticQuery(graphql`
    query {
      tea: imageSharp(
        fluid: { originalName: { regex: "/testimonial-y-1-tea.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      ludvig: imageSharp(
        fluid: { originalName: { regex: "/testimonial-y-2-ludvig.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      estelle: imageSharp(
        fluid: { originalName: { regex: "/testimonial-y-3-estell.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  `);

  const testimonials = [
    {
      testimonial: t('yep-testimonials.testimonials.tea.testimonial'),
      name: t('yep-testimonials.testimonials.tea.name'),
      age: t('yep-testimonials.testimonials.tea.age'),
      category: t('yep-testimonials.testimonials.tea.category'),
      image: images.tea,
    },
    {
      testimonial: t('yep-testimonials.testimonials.ludvig.testimonial'),
      name: t('yep-testimonials.testimonials.ludvig.name'),
      age: t('yep-testimonials.testimonials.ludvig.age'),
      category: t('yep-testimonials.testimonials.ludvig.category'),
      image: images.ludvig,
    },
    {
      testimonial: t('yep-testimonials.testimonials.estelle.testimonial'),
      name: t('yep-testimonials.testimonials.estelle.name'),
      age: t('yep-testimonials.testimonials.estelle.age'),
      category: t('yep-testimonials.testimonials.estelle.category'),
      image: images.estelle,
    },
  ];

  return (
    <Section>
      <Testimonials>
        {testimonials.map((testimonial, i) => {
          return (
            <Testimonial key={i}>
              <ImageWrapper>
                <Img fluid={testimonial.image.fluid} />
              </ImageWrapper>
              <Quote>
                <p>{`"${testimonial.testimonial}"`}</p>
                <footer>
                  <p>
                    <span>{`${testimonial.name}, ${testimonial.age}`}</span>
                  </p>
                  <p>{testimonial.category}</p>
                </footer>
              </Quote>
            </Testimonial>
          );
        })}
      </Testimonials>

      <VideoSection>
        <Text mb={[3]} fontWeight="bold" fontSize={[8, 9]}>
          {t('yep-testimonials.heading')}
        </Text>
        <VideoContainer>
          <VideoIFrame
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/IC_nlcsu4uU"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </VideoContainer>
      </VideoSection>
    </Section>
  );
};

const Section = styled.section`
  grid-column: center-start / center-end;
`;

const Testimonials = styled.div`
  display: grid;
  row-gap: 25px;
  margin-bottom: 5rem;
`;
const Testimonial = styled.article`
  width: 100%;
  display: grid;
  grid-gap: 25px;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'Image Content';
  align-items: center;

  &:nth-child(2n) {
    grid-template-areas: 'Content Image';
    grid-template-columns: 1fr 1fr;
    justify-self: end;
  }

  ${Media.tablet} {
    width: 90%;
    grid-template-columns: 0.6fr 1fr;
    &:nth-child(2n) {
      grid-template-columns: 1fr 0.6fr;
    }
  }
`;
const ImageWrapper = styled.div`
  grid-area: Image;
`;
const Quote = styled.blockquote`
  grid-area: Content;

  & > p {
    font-size: 2.7rem;
    font-family: 'Playfair Display';
    margin-bottom: 1.5rem;

    @media ${device.mobileL} {
      font-size: 1.7rem;
    }
  }

  & > footer {
    font-size: 1.8rem;

    & span {
      font-weight: 700;
    }
  }
`;

const VideoSection = styled.div``;

const VideoContainer = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
`;

const VideoIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

export default YepTestimonials;
